import Screen from 'components/layout/Screen'
import Spinner from 'components/Spinner'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import Container from 'react-bootstrap/Container'
import Order from 'state/models/Order'
import OrderContext from './_context'
import Header from './Header'

export default function BasicOrder({ title, pageTitle }) {
	const order = useContext(OrderContext)
	const icon  = order.fake? 'thumbtack' : Order.ICONS[order.statusSlug]
	return <Screen back={order.statusSlug} {...{ title, pageTitle }}>
		<Container>
			{!order.fake && <Header temp order={order} isCancelled={order.is_cancelled} isCompleted={order.is_completed}/>}
			<div className="empty-area"><Spinner icon={icon}/></div>
		</Container>
	</Screen>
}

BasicOrder.propTypes = {
	title    : PropTypes.node.isRequired,
	pageTitle: PropTypes.node.isRequired,
}
